// extracted by mini-css-extract-plugin
export var aniSpin = "Pagination-module--ani-spin--Z-4y9";
export var button = "Pagination-module--button--kbqQZ";
export var button__inner = "Pagination-module--button__inner--rFlf4";
export var button__text = "Pagination-module--button__text--NpYE8";
export var container = "Pagination-module--container--03PH5";